import AppDataService from "./AppDataService";

export default class InventoryService {
  static async getInventoryList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchValue ? `searchValue=${data.searchValue}` : "",
      data?.type ? `type=${data?.type}` : "",
      data?.status ? `status=${data?.status}` : "",
      data?.dashboard ? `dashboard=${data?.dashboard}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`admin/inventory${queryString}`);
  }

  static async addInventoryList(data) {
    return await AppDataService.post(`admin/inventory`, data);
  }

  static async updateInventoryList(id, data) {
    return await AppDataService.patch(`admin/inventory/${id}`, data);
  }

  static async deleteInventory(id, data) {
    return await AppDataService.delete(`admin/inventory/${id}`, data);
  }

  static async uploadInventoryFile(fileData) {
    return await AppDataService.post(`admin/upload/inventory`, fileData);
  }

  // Distribute master inventory stock to a facility: adds to facility current stock and
  // deducts from master stock. `data` = { facilityId, items:[{ itemId, quantity }] }.
  static async sendInventoryToFacility(data) {
    return await AppDataService.post(
      `facility-order-inventory-notes/bulk/distribute`,
      data
    );
  }
}
